import clsx from 'clsx';
import { motion } from 'framer-motion';
import React from 'react';
import { Icon } from '../../Icon';
import { Typography } from '../../Typography';
import { ToastType } from '../enums/ToastType';
import styles from './Toast.module.scss';

interface SnackbarProps {
	text: string;
	type: ToastType;
}

export const Toast = ({ type, text }: SnackbarProps) => {
	const toastClass = clsx(styles.toast, type === ToastType.INFO ? styles.info : styles.error);

	return (
		<div className={styles.container}>
			<motion.div
				initial={{ opacity: 0, y: 50 }}
				animate={{ opacity: 1, y: 0 }}
				exit={{ opacity: 0, y: 50 }}
				transition={{ duration: 0.3 }}
				className={toastClass}
			>
				<Typography variant='footnote' color='white' textTransform='uppercase' as='p' className={styles.text}>
					{text}
				</Typography>
				{type === ToastType.INFO ? (
					<Icon name='sprite/mark-icon' color='white' size={20} className={styles.icon} />
				) : (
					<Icon name='sprite/dismiss-icon' color='white' size={20} className={styles.icon} />
				)}
			</motion.div>
		</div>
	);
};
